import PropTypes from "prop-types";
import styles from "./style.module.scss";
const GenericButton = ({ title, onClick }) => {
  return (
    <button className={styles.button} onClick={onClick}>
      {title}
    </button>
  );
};



export default GenericButton;
